export default (props) => (
  <svg {...props} viewBox="0 0 30 30" aria-hidden="true" focusable="false">
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h30v30H0z" />
      <path
        d="M24.52 4.842c.882.882-.328 3.857-1.693 5.222-.368.368-1.33 1.266-2.885 2.692l4.499 8.861a1 1 0 01-.185 1.16l-.675.675a1 1 0 01-1.52-.123l-5.43-7.55c-1.852 1.684-4.109 3.73-6.77 6.136l1.098 2.833a.852.852 0 01-.192.911.556.556 0 01-.785 0l-6.286-6.285a.556.556 0 010-.786.858.858 0 01.912-.195l2.847 1.085c2.4-2.653 4.44-4.904 6.121-6.752l-7.55-5.432a1 1 0 01-.123-1.52l.675-.675a1 1 0 011.16-.184L16.6 9.413c1.428-1.557 2.325-2.519 2.691-2.884 1.355-1.356 4.346-2.57 5.228-1.687z"
        fill="currentColor"
        fillRule="nonzero"
      />
    </g>
  </svg>
);
